import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciTabsComponent } from './luci-tabs.component';



@NgModule({
  declarations: [LuciTabsComponent],
  exports: [LuciTabsComponent],
  imports: [
    CommonModule
  ]
})
export class LuciTabsModule { }
